module.exports = __webpack_public_path__ + "img/happybrain_info3.2b0cf89c.jpg";